module.exports = "/_next/static/images/0ac411820030fe6689189418c577f709-savings-md.jpg";